<template>
    <div>
        <div class="actions" v-if="type !== 'edit'">
            <b-button variant="success" @click="openModal(true, 'add')"> {{$t('general.add')}}</b-button>
        </div>
        <b-table-simple hover responsive>
            <b-thead>
                <b-th> {{$t('customer.products.productNo')}} </b-th>
                <b-th> {{$t('customer.products.productSerialNo')}} </b-th>
                <b-th> {{$t('customer.products.purchaseDate')}} </b-th>
                <b-th> {{$t('customer.products.updatedAt')}} </b-th>
                <b-th> {{$t('customer.products.actions')}} </b-th>
            </b-thead>
            <b-tbody>
                <b-tr v-for="product in customerProducts" :key="product.id">
                    <b-td> {{product.productId}} </b-td>
                    <b-td> {{product.productSeriNo}} </b-td>
                    <b-td> {{moment(product.date)}} </b-td>
                    <b-td> {{moment(product.updatedAt)}} </b-td>
                    <b-td> 
                        <b-icon 
                            icon="pencil-square" 
                            variant="primary"
                            scale="1.5" 
                            shift-v="1.5" 
                            aria-hidden="true"
                            :title="$t('general.edit')" 
                            @click="openModal(true, 'edit', {product, data: customer.data})" 
                        />
                        <b-icon
                            icon="trash"
                            variant="danger"
                            scale="1.5"
                            shift-v="1.5"
                            aria-hidden="true"
                            :title="$t('general.delete')"
                            @click="openModal(true, 'delete', {product, customer})" 
                        />
                    </b-td>
                </b-tr>
            </b-tbody>
        </b-table-simple>
        <Modals :open="modalOpen" :modalEvent="openModal" :modalProps="modalProps" :form="currentForm" :modalName="modalName" />

    </div>

</template>
               
<script>
    import Modals from "../modals/"
    import moment from 'moment'
    
    export default {
        name: "Product",
        computed: {
            customerProducts(){
                return this.$store.getters.getCustomerProducts
            }
        },
        data: function(){
            return{
                modalOpen: false,
                modalProps: {},
                currentForm:"CustomerProducts",
                modalName: ""
            }
        },
        methods:{
            openModal: function(state, modal, props){
                this.modalOpen = state
                if(state){
                    this.modalProps = props
                    this.modalName = modal
                }
            },
            moment: function(data){
                if (data == '0001-01-01T00:00:00Z') return 'Girilmedi' 
                return moment(data).format('DD MMMM YYYY');
            }
        },
        props:{
            customer: Object,
            type: String
        },
        components:{
            Modals
        }
    }
</script>

<style lang="css" scoped > 
    @import "../styles/subscriptions.min.css"; 
</style>


// WEBPACK FOOTER //
// src/pages/General/Customer/components/Product.vue